var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPitcher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 3.516h-8.347a2.288 2.288 0 01-2.058-1.272A4.037 4.037 0 007.675 0H1.553L4.66 4.66v3.176L2.56 20.22a12.376 12.376 0 002.273 9.428l.264.353h14.358l.264-.353a12.377 12.377 0 002.273-9.428l-1.937-11.43h1.655c.807 0 1.464.657 1.464 1.465v6.035a2.64 2.64 0 002.637 2.637 2.64 2.64 0 002.637-2.637v-6.035a6.746 6.746 0 00-6.738-6.738zM7.676 1.758c.877 0 1.666.487 2.058 1.272a4.037 4.037 0 003.63 2.243h4.773v1.758H6.418V4.128l-1.58-2.37h2.837zM20.26 20.513a10.615 10.615 0 01-1.697 7.73H5.991a10.615 10.615 0 01-1.697-7.73L6.281 8.789h11.992l1.987 11.724zm6.431-4.224a.88.88 0 01-1.758 0v-6.035a3.226 3.226 0 00-3.222-3.223h-1.817V5.273h1.817a4.986 4.986 0 014.98 4.98v6.036z",
    fill: "#91C300",
    stroke: "#91C300"
  })));
}

export default SvgPitcher;